import { z } from 'zod'

import { AbTestSlice } from 'features/ab-tests/hooks/useGetAbTest'
import { abTestsCommonSchema } from '../AbTestsCommonForm/abTestsCommonSchema'

export const abTestsEditSchema = z.object({}).extend(abTestsCommonSchema.shape)

export type AbTestsEditSchema = z.infer<typeof abTestsEditSchema>

export const abTestsEditSchemaDefaults = (abTest: AbTestSlice): AbTestsEditSchema => {
  const {
    cookieLifetime,
    domain: { id: domainId },
    name,
    trafficSplitType,
  } = abTest

  return {
    cookieLifetime,
    domainId,
    name,
    trafficSplitType,
  }
}
